export enum ButtonIconType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum ButtonIconSize {
  XS = '12px',
  SM = '16px',
  RG = '20px',
  MD = '24px',
  LG = '32px',
  XL = '40px',
  XXL = '48px',
  XXXL = '56px'
}
